import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Modal, Button, Form } from "react-bootstrap";

const UpcomingEvents = () => {
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    desc: "",
    address: "",
    start_time: "",
    end_time: "",
    date: "",
  });

  // Fetch events
  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await axios.get("https://api.biznetusa.com/api/all-upcomingevents");
      setEvents(response.data.upcomingevents);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Open modal for adding/updating
  const handleShowModal = (event = null) => {
    if (event) {
      setFormData({ ...event });
      setCurrentEvent(event);
    } else {
      setFormData({
        title: "",
        desc: "",
        address: "",
        start_time: "",
        end_time: "",
        date: "",
      });
      setCurrentEvent(null);
    }
    setShowModal(true);
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Add or update event
  const handleSubmit = async () => {
    try {
      if (currentEvent) {
        // Update event
        await axios.put(`https://api.biznetusa.com/api/update-upcomingevents/${currentEvent.id}`, formData);
      } else {
        // Add event
        await axios.post("https://api.biznetusa.com/api/store-upcomingevents", formData);
      }
      fetchEvents();
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting event:", error);
    }
  };

  // Delete event
  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://api.biznetusa.com/api/deleteupcomingevents/${id}`);
      fetchEvents();
    } catch (error) {
      console.error("Error deleting event:", error);
    }
  };

  return (
    <div className="container mt-5">
      <h1>Upcoming Events</h1>
      <Button className="mb-3" onClick={() => handleShowModal()}>Add Event</Button>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Description</th>
            <th>Address</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event, index) => (
            <tr key={event.id}>
              <td>{index + 1}</td>
              <td>{event.title}</td>
              <td>{event.desc}</td>
              <td>{event.address}</td>
              <td>{event.start_time}</td>
              <td>{event.end_time}</td>
              <td>{event.date}</td>
              <td>
                <Button
                  variant="warning"
                  className="me-2"
                  onClick={() => handleShowModal(event)}
                >
                  Edit
                </Button>
                <Button
                  variant="danger"
                  onClick={() => handleDelete(event.id)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Add/Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{currentEvent ? "Edit Event" : "Add Event"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Enter title"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                name="desc"
                value={formData.desc}
                onChange={handleChange}
                placeholder="Enter description"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter address"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Start Time</Form.Label>
              <Form.Control
                type="time"
                name="start_time"
                value={formData.start_time}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>End Time</Form.Label>
              <Form.Control
                type="time"
                name="end_time"
                value={formData.end_time}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {currentEvent ? "Update" : "Add"} Event
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UpcomingEvents;
